import {Component} from '@angular/core';
import {BaseComponent} from "../base/base.component";
import {IncomingMessageXBVO} from "../model/xbvo.model";
import {RestClient} from "../rest-client.service";
import {DateUtilsBs} from "../base/utils/dateUtilsBs";
import {AuthService} from "../base/auth/auth.service";

/**
 * App-Component
 */
@Component({
    selector: '<skitbs-messages>',
    template: `
        <skitbs-template [title]="v('menu_messages')" xmlns:p="http://www.w3.org/1999/html">

            <!-- Message list -->
            <p-table [value]="modelMessages" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{v('subject')}}</th>
                        <th>{{v('date')}}</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-pMessage>
                    <tr [class.SoftGrayBack]="pMessage == modelSelectedMessage">
                        <td class="BsTexBreak PadL" [class.FontBold]="!pMessage.readed">
                            <a (click)="onSelectMessage(pMessage)">
                                <div>
                                    {{pMessage.subject}}
                                    <span *ngIf="!pMessage.subject">--------</span>
                                </div>
                            </a>
                        </td>
                        <td class="TexAlCenter BsWid60p">{{dateFormat(pMessage.created, 'dd.MM.')}}</td>
                        <td class="TexAlCenter BsWid30p">
                            <a (click)="onDeleteMessage(pMessage)">
                                <i class="pi pi-trash "></i>
                            </a>
                        </td>
                    </tr>
                </ng-template>
            </p-table>

            <!-- no messages -->
            <div class="TexAlCenter" *ngIf="!modelMessages">{{v('no_messages')}}</div>

            <!-- Message body -->
            <div class="EmptyBox1 OrangeBack"></div>
            <div class="PadAll MarV" *ngIf="messageVisible && modelSelectedMessage && modelSelectedMessage.body">
                <div [innerHTML]="modelSelectedMessage.body"></div>
                <div class="EmptyBox20"></div>
            </div>
            <div class="EmptyBox1 OrangeBack"></div>

            <!-- new Message -->
            <div class="Separator"></div>
            <div class="SoftGrayBack2 PadAll">
                <div class="MarAll" (click)="onToggleNewMessage()">
                    <i class="pi pi-plus-circle MarR"></i>Neue Nachricht
                </div>
                <ng-container *ngIf="modelNew">
                    <div>
                        <input pInputText [(ngModel)]="modelNewSubject" [placeholder]="v('subject')" [ngClass]="'BsFsSmall Wid100'">
                    </div>
                    <div class="d-flex" style="margin-top: 2px;">
                        <textarea pInputTextarea [(ngModel)]="modelNewBody" [rows]="3" [placeholder]="v('message')" [ngClass]="'d-col BsFsSmall'" #_body></textarea>
                    </div>
                    <div class="TexAlCenter PadT">
                        <button pButton label="Senden" (click)="onSendMessage()" [icon]="'pi pi-send'"></button>
                    </div>
                    <div class="EmptyBox5"></div>
                </ng-container>
            </div>
            <div class="Separator"></div>

            <div class="EmptyBox20"></div>
        </skitbs-template>
    `
})
export class MessagesComponent extends BaseComponent {

    modelMessages: IncomingMessageXBVO[] = [];
    modelSelectedMessage: IncomingMessageXBVO;
    modelNew: boolean = false;
    modelNewSubject: string;
    modelNewBody: string;
    messageVisible: boolean = false;

    constructor(private authService: AuthService, private restClient: RestClient) {
        super();
    }

    /**
     * Lifecycle.
     */
    ngOnInit(): void {
        let pToday = new Date();
        let pStartDate = DateUtilsBs.addDays(pToday, -7);
        this.onSearch();
    }


    /**
     * Action.
     * @private
     */
    private onSearch() {
        this.restClient
            .messages()
            .subscribe(aXBVO => {
                this.modelMessages = aXBVO.incomingMessage;
                this.modelSelectedMessage = aXBVO.incomingMessage.length > 0 ? aXBVO.incomingMessage[0] : null;
            });
    }

    /**
     * Action.
     * @param aMessage
     */
    public onSelectMessage(aMessage: IncomingMessageXBVO) {
      this.messageVisible = true;
        this.modelSelectedMessage = aMessage;
        this.restClient.messageReaded(aMessage.deliveryId).subscribe(aXBVO => {
          if (this.modelSelectedMessage.readed === null) {
            this.modelSelectedMessage.readed = new Date();
            let pSession = this.authService.findCurrentSession();
            this.authService.updateIncomingMessages(pSession.incomingMessages - 1);
          }
        });
    }

    /**
     * Action.
     * @param aMessage
     */
    public onSendMessage() {
        if (!this.modelNewBody || !this.modelNewSubject) {
            return;
        }

        let pNew = new IncomingMessageXBVO();
        pNew.subject = this.modelNewSubject;
        pNew.body = this.modelNewBody;
        this.restClient.messageSend(pNew).subscribe((aXBVO => {
            this.modelNewBody = null;
            this.modelNewSubject = null;
            this.toastInfo(this.v("message_sent"));
            // reload
            this.onSearch();
            this.modelNew = false;
        }));
    }

    /**
     * Action.
     * @param aMessageId
     */
    public onDeleteMessage(aMessage: IncomingMessageXBVO) {
        this.restClient.messageDelete(aMessage.deliveryId).subscribe(aXBVO => {
            this.toastInfo(this.v('message_deleted'));
            this.modelMessages.splice(this.modelMessages.indexOf(aMessage), 1);
        });
    }

    /**
     * Action.
     */
    public onToggleNewMessage() {
        this.modelNew = !this.modelNew;
    }
}

